<div class="error-banner" role="alert" aria-live="polite">
  <split-icon class="error-banner__icon" name="alert" size="16"></split-icon>
  <p class="error-banner__message">{{ message || fallbackMessage }}</p>
</div>
